import { DropDownItem } from '../../../fields/dropdown-item.model';
import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';


export class MdmDropDownItemsTable extends Table<{ [key: string]: { range: Range, items: DropDownItem[]; }; }> {
  constructor(
    range: Range) {
    super(range, false, {});
  }

  add(taxonomyId: number, fieldId: number, items: DropDownItem[]): boolean {
    if (!this.exists(taxonomyId, fieldId)) {
      const rowCount = items.length * 3 /* ids + codes + values */ + 1; /* items count */
      const rowDiff = rowCount - (this.range.rowCount - 1 /* header*/);

      if (rowDiff > 0) {
        this.range.rowCount += rowDiff;
      }

      if (this.containsData) {
        this.range.columnCount++;
      } else {
        this.containsData = true;
      }

      const key = this.getKey(taxonomyId, fieldId);
      const range = new Range(
        items.length * 2 /* ids + codes */ + 2 /* header + items count */,
        this.range.lastColumnIndex,
        items.length,
        1,
        this.range.sheetName);

      this.cache[key] = { range: range, items: items };
      return true;
    }

    return false;
  }

  remove(taxonomyId: number, fieldId: number): boolean {
    if (this.exists(taxonomyId, fieldId)) {
      const key = this.getKey(taxonomyId, fieldId);

      delete this.cache[key];

      if (this.range.columnCount == 1) {
        this.containsData = false;
      } else {
        this.range.columnCount--;
      }

      return true;
    }

    return false;
  }

  getItems(taxonomyId: number, fieldId: number): DropDownItem[] {
    const key = this.getKey(taxonomyId, fieldId);
    const items = this.cache[key]?.items;

    return items ? [...items] : undefined;
  }

  getRange(taxonomyId: number, fieldId: number): Range {
    const key = this.getKey(taxonomyId, fieldId);
    return this.cache[key]?.range;
  }

  exists(taxonomyId: number, fieldId: number): boolean {
    const key = this.getKey(taxonomyId, fieldId);
    return this.cache.hasOwnProperty(key);
  }

  private getKey(taxonomyId: number, fieldId: number): string {
    return fieldId + '|' + taxonomyId;
  }
}